import React from "react";
import nextId from "react-id-generator";
import { Route, Switch, useHistory, useParams } from "react-router";
import "./sign-up-component.style.scss";
import SignUpCandidate from "./SignUpCandidate/SignUpCandidate";
import SignUpInstitute from "./SignUpInstitute/SignUpInstitute";
export default function SignUpComponent({ modal,indirect, setMainType = () => {} }) {
  const history = useHistory();
  const { signUpType } = useParams();
  const [selectedOption, setSelectedOption] = React.useState(options[0]);
  React.useEffect(() => {
    if (signUpType === "candidate" || indirect === "candidate") {
      setSelectedOption(options[0]);
      setMainType(options[0]);
    } else {
      setSelectedOption(options[1]);
      setMainType(options[1]);
    }
  }, [signUpType]);
  return (
    <div className="sign-up-component-main">
      <header className="suc-header">
        <h2>Signing Up</h2>
      </header>
      <div className="suc-options">
        <div
          className={
            selectedOption.id === "candidate" ? "left-most" : "right-most"
          }
        />
        {options.map((obj) => (
          <h6
            onClick={() => {
              if(modal)return
              setMainType(obj);
              setSelectedOption(obj);
              history.push(`/sign-up/${obj.id}`);
            }}
            className={obj.id === selectedOption.id ? "selected" : ""}
            key={obj.keyId}
          >
            {obj.text}
          </h6>
        ))}
      </div>
      {!modal ? (
        <Switch>
          <Route path="/sign-up/candidate" render={() => <SignUpCandidate />} />
          <Route
            path="/sign-up/institution"
            render={() => <SignUpInstitute />}
          />
        </Switch>
      ) : selectedOption.id === "candidate" ? (
        <SignUpCandidate />
      ) : (
        <SignUpInstitute />
      )}
    </div>
  );
}

const options = [
  { keyId: nextId(), id: "candidate", text: "For Candidates" },
  { keyId: nextId(), id: "institution", text: "For Institutes" },
];
